import { call, put, takeEvery } from 'redux-saga/effects';
import { ContentfulLocale, isSysLink } from '@dcl/schemas';
import { isErrorWithMessage } from '../../lib';
import { FETCH_CAMPAIGN_REQUEST } from './actions';
import { fetchCampaignSuccess, fetchCampaignFailure } from './actions';
const ADMIN_CONTENT_TYPE = 'admin';
const BANNER_CONTENT_TYPE = 'banner';
const MARKETING_CAMPAIGN_CONTENT_TYPE = 'marketingCampaign';
export function* campaignSagas(client, config) {
    yield takeEvery(FETCH_CAMPAIGN_REQUEST, handleFetchCampaignRequest);
    function* handleFetchCampaignRequest(_) {
        try {
            const { items, includes } = (yield call([client, 'fetchEntry'], config.space, config.environment, config.id, ADMIN_CONTENT_TYPE, config.token));
            if (!items || (items && items.length === 0)) {
                throw new Error('Failed to fetch campaign data');
            }
            const assets = (includes.Asset ?? []).reduce((acc, asset) => {
                acc[asset.sys.id] = asset;
                return acc;
            }, {});
            const entries = (includes.Entry ?? []).reduce((acc, entry) => {
                acc[entry.sys.id] = entry;
                return acc;
            }, {});
            const banners = Object.entries(items[0].fields).reduce((acc, [key, value]) => {
                const fieldOnLocale = value[ContentfulLocale.enUS];
                if (isSysLink(fieldOnLocale)) {
                    const linkedEntryId = fieldOnLocale.sys.id;
                    const bannerEntry = entries[linkedEntryId];
                    if (bannerEntry &&
                        bannerEntry.sys.contentType.sys.id === BANNER_CONTENT_TYPE) {
                        acc[key] = {
                            ...bannerEntry.fields,
                            id: linkedEntryId
                        };
                    }
                }
                return acc;
            }, {});
            const campaignField = Object.values(items[0].fields).find(field => {
                const fieldOnLocale = field[ContentfulLocale.enUS];
                if (isSysLink(fieldOnLocale)) {
                    const entry = entries[fieldOnLocale.sys.id];
                    if (entry.sys.contentType.sys.id === MARKETING_CAMPAIGN_CONTENT_TYPE) {
                        return entry.fields;
                    }
                }
                return false;
            });
            const campaignFields = campaignField?.[ContentfulLocale.enUS].sys.id
                ? entries[campaignField?.[ContentfulLocale.enUS].sys.id]
                    ?.fields
                : undefined;
            yield put(fetchCampaignSuccess(banners, assets, campaignFields?.name, campaignFields?.marketplaceTabName, campaignFields?.mainTag?.[ContentfulLocale.enUS], campaignFields?.additionalTags?.[ContentfulLocale.enUS]));
        }
        catch (error) {
            yield put(fetchCampaignFailure(isErrorWithMessage(error) ? error.message : 'Error fetching campaign'));
        }
    }
}
//# sourceMappingURL=sagas.js.map